import type { PreflightReportDetail } from "../types/preflight.types";

function normalize(value: string): string {
  return value.trim().toLowerCase();
}

/** Brand is shown only when it adds context beyond the report title. */
export function shouldShowBrandName(report: Pick<PreflightReportDetail, "name" | "brandName">): boolean {
  return normalize(report.brandName) !== normalize(report.name);
}

export function formatReportContext(labels: { platform: string; placement: string }): string {
  return `${labels.platform} · ${labels.placement}`;
}

/** Localized "Jun 14, 2026, 10:48" timestamp for report provenance (header byline). */
export function formatReportTimestamp(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/** List/table rows — may include brand when it differs from the report name. */
export function formatReportSubtitle(
  report: Pick<PreflightReportDetail, "name" | "brandName" | "platform" | "placement">,
  labels: { brand: string; platform: string; placement: string },
): string {
  const context = formatReportContext(labels);
  return shouldShowBrandName(report) ? `${labels.brand} · ${context}` : context;
}
